export default "__VITE_ASSET__CskRNDW7__"